import { lazy, type ComponentType } from "react";

/** Recover once from a stale Vite chunk URL after a preview/deployment update. */
export function lazyPage<T extends ComponentType<object>>(name: string, load: () => Promise<{ default: T }>) {
  const retryKey = `mcg:lazy-retry:${name}`;
  return lazy(async () => {
    try {
      const page = await load();
      sessionStorage.removeItem(retryKey);
      return page;
    } catch (error) {
      const transient = error instanceof TypeError && /dynamically imported module|fetch/i.test(error.message);
      if (transient && !sessionStorage.getItem(retryKey)) {
        sessionStorage.setItem(retryKey, "1");
        window.location.reload();
        // Navigation replaces this page; keep the suspense fallback visible meanwhile.
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });
}